import { render, staticRenderFns } from "./ApplyForPermitPage.vue?vue&type=template&id=3e0b4237&"
import script from "./ApplyForPermitPage.vue?vue&type=script&lang=js&"
export * from "./ApplyForPermitPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports